import React from "react"
import { useRouteError } from "react-router"

import { ConnectivityErrorScreen } from "@/components/connectivity-error/connectivity-error-screen"
import { ErrorBoundaryContentFallback } from "@/components/error-boundary/error-boundary-content-fallback"
import { logError } from "@/components/error-boundary/error-boundary-fallback-utils"
import { isConnectivityError } from "@/utils/api"

import { useRetryConnectivityRecovery } from "../use-retry-connectivity-recovery"

export const RouteErrorElement = () => {
  const error = useRouteError()
  const { isRetrying, retry } = useRetryConnectivityRecovery()

  React.useEffect(() => {
    if (!isConnectivityError(error)) {
      logError(error, { componentStack: "\n    at RouteErrorElement" })
    }
  }, [error])

  if (isConnectivityError(error)) {
    return <ConnectivityErrorScreen isRetrying={isRetrying} onRetry={retry} />
  }

  return <ErrorBoundaryContentFallback fullScreen />
}
